<template>
  <div class="home-layout">
    <section>
      <router-view />
    </section>
    <footer>
      <home-layout-footer />
    </footer>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import HomeLayoutFooter from "@/components/layout/home_layout/HomeLayoutFooter.vue";
import { store } from "@/store";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "HomeLayout.vue",
  components: {
    HomeLayoutFooter,
  },
  setup() {
    const route = useRoute();

    return {};
  },
});
</script>
